import { type ReactNode, useEffect, useState } from "react";

import { pushDataLayer } from "~/hec/analytics/data-layer.client";
import { useBalance } from "~/hec/components/fsa-funds/use-balance";

import { SpenderContext, type SpenderData } from "./spender-context";

/**
 * The FSA Spender page's shared state (COM-258/261/474/478): the loader data
 * and the shopper's balance, which the grid filters by and the ribbon shows.
 * Sits above the Builder body, so the blocks keep it across Builder's
 * snapshot-to-live swap.
 */
export function SpenderProvider({
  data,
  persist = false,
  children,
}: {
  data: SpenderData;
  persist?: boolean;
  children: ReactNode;
}) {
  const [balance, setBalance, clearBalance, restored] = useBalance({
    persist,
  });
  const [dismissed, setDismissed] = useState(false);
  // Legacy page parity only (COM-250 AC3): the legacy page pushes a bare
  // smart_spender on load; no GTM trigger consumes it (none found).
  useEffect(() => {
    pushDataLayer({ event: "smart_spender" });
  }, []);
  return (
    <SpenderContext.Provider
      value={{
        data,
        balance,
        setBalance,
        clearBalance,
        restored,
        dismissed,
        setDismissed,
      }}
    >
      {children}
    </SpenderContext.Provider>
  );
}
